import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';

function AdminSkills() {
  const [submissions, setSubmissions] = useState([]);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchSubmissions = async () => {
      try {
        const playerId = localStorage.getItem('playerId');
        if (!playerId) {
          throw new Error('No player ID found in localStorage');
        }
        const res = await fetch(`${API_BASE_URL}/admin/skill-submissions`, {
          headers: { 'player-id': playerId }
        });
        console.log('Fetch admin submissions status:', res.status);
        console.log('Fetch admin submissions headers:', res.headers.get('Content-Type'));
        const text = await res.text();
        console.log('Fetch admin submissions body:', text);
        if (!res.ok) {
          try {
            const errorData = JSON.parse(text);
            throw new Error(errorData.error || 'Failed to fetch submissions');
          } catch {
            throw new Error('Server returned non-JSON response: ' + text);
          }
        }
        const data = JSON.parse(text);
        setSubmissions(data.filter(sub => sub.status === 'Pending'));
      } catch (err) {
        console.error('Fetch submissions error:', err);
        setMessage('Error: ' + err.message);
      }
    };
    fetchSubmissions();
  }, []);

  const handleReview = async (submissionId, status, denyReason = '') => {
    try {
      const playerId = localStorage.getItem('playerId');
      if (!playerId) {
        throw new Error('No player ID found in localStorage');
      }
      const res = await fetch(`${API_BASE_URL}/skill-submissions/${submissionId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'player-id': playerId
        },
        body: JSON.stringify({ status, denyReason })
      });
      console.log('Update submission status:', res.status);
      console.log('Update submission headers:', res.headers.get('Content-Type'));
      const data = await res.json();
      console.log('Update submission body:', JSON.stringify(data));
      if (!res.ok) {
        throw new Error(`HTTP ${res.status}: ${data.error || 'Update failed'}`);
      }
      setSubmissions(submissions.filter(sub => sub._id !== submissionId));
      console.log('Updated submissions:', submissions.filter(sub => sub._id !== submissionId));
      setMessage(`Submission ${status.toLowerCase()}!`);
    } catch (err) {
      console.error('Approval error:', err);
      setMessage('Error: ' + err.message);
    }
  };

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'left', padding: '60px 20px' }}>
      <h1 style={{ color: '#1E88E5', fontSize: '2em', marginBottom: '20px' }}>Admin: Skill Submissions</h1>
      {message && (
        <div
          style={{
            backgroundColor: message.includes('Error') ? '#EF5350' : '#4CAF50',
            padding: '10px',
            marginBottom: '20px',
            borderRadius: '5px',
            color: 'white',
            fontWeight: 'bold'
          }}
        >
          {message}
        </div>
      )}
      {submissions.length > 0 ? (
        submissions.map((sub, idx) => (
          <div
            key={idx}
            style={{
              backgroundColor: '#f9f9f9',
              padding: '20px',
              borderRadius: '8px',
              boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
              marginBottom: '20px'
            }}
          >
            <p style={{ color: '#333', fontSize: '16px', marginBottom: '5px' }}>
              Player: {sub.playerId?.username || 'Unknown'}
            </p>
            <p style={{ color: '#333', fontSize: '16px', marginBottom: '5px' }}>
              Staff: {sub.staffName || sub.staffId?.staffName || 'Unknown'} | Skill: {sub.skillName} (Level {sub.level})
            </p>
            <p style={{ color: '#333', fontSize: '16px', marginBottom: '5px' }}>
              Items Used: {sub.itemsUsed?.join(', ') || 'None'}
            </p>
            <p style={{ color: '#333', fontSize: '16px', marginBottom: '5px' }}>
              Evidence: <a href={sub.evidence} target="_blank" rel="noopener noreferrer">{sub.evidence}</a>
            </p>
            <p style={{ color: '#333', fontSize: '16px', marginBottom: '10px' }}>
              Status: {sub.status}
              {sub.denyReason && ` | Reason: ${sub.denyReason}`}
            </p>
            {sub.status === 'Pending' && (
              <div style={{ display: 'flex', gap: '10px' }}>
                <button
                  onClick={() => handleReview(sub._id, 'Approved')}
                  style={{
                    padding: '5px 10px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer'
                  }}
                  onMouseOver={(e) => (e.target.style.backgroundColor = '#388E3C')}
                  onMouseOut={(e) => (e.target.style.backgroundColor = '#4CAF50')}
                >
                  Approve
                </button>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  <input
                    type="text"
                    placeholder="Deny reason"
                    onChange={(e) =>
                      setSubmissions(
                        submissions.map(s =>
                          s._id === sub._id ? { ...s, tempDenyReason: e.target.value } : s
                        )
                      )
                    }
                    style={{ padding: '5px', borderRadius: '5px', border: '1px solid #ccc' }}
                  />
                  <button
                    onClick={() => handleReview(sub._id, 'Denied', sub.tempDenyReason || 'No reason provided')}
                    style={{
                      padding: '5px 10px',
                      backgroundColor: '#EF5350',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer'
                    }}
                    onMouseOver={(e) => (e.target.style.backgroundColor = '#D32F2F')}
                    onMouseOut={(e) => (e.target.style.backgroundColor = '#EF5350')}
                  >
                    Deny
                  </button>
                </div>
              </div>
            )}
          </div>
        ))
      ) : (
        <p style={{ color: '#333', fontSize: '16px' }}>No pending submissions.</p>
      )}
    </div>
  );
}

export default AdminSkills;